import axios from 'axios';

const protocol = process.env.REACT_APP_DAILYPROFIT_BACKEND_PROTOCOL;
const host = process.env.REACT_APP_DAILYPROFIT_BACKEND_HOST;
const port = process.env.REACT_APP_DAILYPROFIT_BACKEND_PORT;

export const get_my_crm_boards = () => axios.get(`${protocol}${host}${port}/sidequests/getMyCrmBoards`);
